import axios from "axios";
import config from "../../config/Config";
import helper from "../../helpers/helper";
import { getToken } from "../../common/Common";

const {
  operationSegmentURL,
  getUserDetailsURL,
  updateUserDetailsURL,
  listingFilterURL,
  searchByDoctorName,
  searchByClinicId,
  searchAPI,
  addNewUserURL,
  citySearchURL,
  renewalSegmantURL,
  addRenewalURL,
  updateRenewalURL,
  customerCareSegmentURL,
  addNewCustomerCareURL,
  updateCustomerCareUserDetailsURL,
  timeLineURL,
  employeeUserList,
} = config;

const action = {
  getOperationSegmentDetails: async function (
    payload,
    getListingDetails,
    token
  ) {
    const requestData = {
      method: "POST",
      url: operationSegmentURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getListingDetails(response?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getUserList: async function (setEmployeeList) {
    const requestData = {
      method: "POST",
      url: employeeUserList,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
    };
    await axios(requestData)
      .then((response) => {
        setEmployeeList(response?.data?.result?.user);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  getUserDetails: async function (token, userDetails) {
    const requestData = {
      method: "POST",
      url: getUserDetailsURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
    };
    await axios(requestData)
      .then((response) => {
        userDetails(response?.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  updateUserDetails: async function (payload, updatedDetailsDesponse) {
    const requestData = {
      method: "POST",
      url: updateUserDetailsURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        updatedDetailsDesponse(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getFilteredListDetails: async function (payload, getListingDetails) {
    const requestData = {
      method: "POST",
      url: listingFilterURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getListingDetails(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getSearchResponse: async function (payload, getData) {
    const requestData = {
      method: "POST",
      url: searchAPI,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },

  addNewUserAPI: async function (payload, addedUser) {
    const requestData = {
      method: "POST",
      url: addNewUserURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        addedUser(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getCitiesAPI: async function (payload, searchCityResponse) {
    const requestData = {
      method: "POST",
      url: citySearchURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        searchCityResponse(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getRenewalListAPI: async function (payload, getRenewalData) {
    const requestData = {
      method: "POST",
      url: renewalSegmantURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getRenewalData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  addRenewalAPI: async function (payload, addedUser) {
    const requestData = {
      method: "POST",
      url: addRenewalURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        addedUser(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  updateRenewalAPI: async function (payload, updatedDetailsDesponse) {
    const requestData = {
      method: "POST",
      url: updateRenewalURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        updatedDetailsDesponse(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getFilteredRenewalListDetails: async function (payload, getListingDetails) {
    const requestData = {
      method: "POST",
      url: renewalSegmantURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getListingDetails(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getCustomerCareListAPI: async function (payload, getCustomerCareData) {
    const requestData = {
      method: "POST",
      url: customerCareSegmentURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getCustomerCareData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getCustomerCareListExcelAPI: async function (payload, getCustomerCareExcelData) {
    const requestData = {
      method: "POST",
      url: customerCareSegmentURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getCustomerCareExcelData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  getFilteredCustomerCareListDetails: async function (
    payload,
    getCustomerCareData
  ) {
    const requestData = {
      method: "POST",
      url: customerCareSegmentURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getCustomerCareData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  addCustomerCareUserAPI: async function (payload, addedUser) {
    const requestData = {
      method: "POST",
      url: addNewCustomerCareURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        addedUser(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
  updateCustomerCareDetails: async function (payload, updatedDetailsDesponse) {
    const requestData = {
      method: "POST",
      url: updateCustomerCareUserDetailsURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        updatedDetailsDesponse(response.data);
      })
      .catch((error) => {
        updatedDetailsDesponse([]);
        console.error(error);
      });
  },
  getTimeLineDetails: async function (payload, getTimeLineData) {
    const requestData = {
      method: "POST",
      url: timeLineURL,
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        Authorization: getToken(),
      },
      data: payload,
    };
    await axios(requestData)
      .then((response) => {
        getTimeLineData(response.data);
      })
      .catch((error) => {
        console.error(error);
      });
  },
};
export default action;
